import useDocument, { DocumentConfig } from './useDocument';
import { Invoice, InvoiceStatus } from '../models/invoice';

const config: DocumentConfig = {
  listKey: 'invoices',
  detailKey: 'invoice',
  basePath: 'invoice',
  archivePath: (id) => `invoice/archiveInvoice/${id}`,
  voidPath: (id) => `invoice/voidInvoice/${id}`,
  voidType: 'Invoice', // EPIC_VOID_FLOW_2026-10
  finalizePath: (id) => `invoice/finalizeInvoice/${id}`,
  statusPath: (id) => `invoice/changeInvoiceStatus/${id}`,
  statusAsJson: true,
};

const useInvoice = (props: { id?: string }) => useDocument<InvoiceStatus, Invoice>(config, props);

export default useInvoice;
